import * as U from 'karet.util';

export const ClinicalSign = {
  create: ({ name = '', description = '' } = {}) => ({ name, description }),
  name: U.view('name'),
  description: U.view('description'),
};
